const paramsSerializer = (parametrosDoSerializador: object) => {
  const ORDENAR_POR: Function = (ordenarPor: string[] | string) => {
    if (Array.isArray(ordenarPor)) {
      return ordenarPor.map((ordenador) => `ordenar-por=${ordenador}`).join("&")
    }

    return `ordenar-por=${ordenarPor}`
  }

  const SERIALIZADORES_SUPORTADOS = {
    "ordenar-por": ORDENAR_POR,
  }

  const montarListaComParametrosSerializados = (parametros: object) => {
    const funcaoSerializadoraGenerica =
      (chave: string) => (valorDoParametro: string) =>
        `${chave}=${valorDoParametro}`
    const valoresSerializados: string[] = []

    Object.keys(parametros).forEach((chave) => {
      if (parametros[chave]) {
        const funcaoSerializadora =
          SERIALIZADORES_SUPORTADOS[chave] || funcaoSerializadoraGenerica(chave)
        const valorDoParametro = parametros[chave]

        valoresSerializados.push(funcaoSerializadora(valorDoParametro))
      }
    })
    return valoresSerializados
  }

  const unificarParametrosEmString = (listaDeParametros: string[]) => {
    return listaDeParametros.join("&")
  }

  return unificarParametrosEmString(
    montarListaComParametrosSerializados(parametrosDoSerializador)
  )
}

export function usarSerializador() {
  return {
    paramsSerializer,
  }
}
